var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"color":"#727273","margin-top":"20px","text-align":"center"}},[_c('span',[_vm._v("欢迎"+_vm._s(_vm.$store.getters.expertLoginUser.pexpertname)+"评审人评审项目")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }